import {CompanyScoreType} from "@SearchResults/features/sidebar/features/companyFilters/types/CompanyScore.type";

const poor: CompanyScoreType = {
    label: 'poor',
    from: 0,
    to: 4,  // 0-3 (0 <= score < 4)
};

const fair: CompanyScoreType = {
    label: 'fair',
    from: 4,
    to: 6,  // 4-5 (4 <= score < 6)
};

const good: CompanyScoreType = {
    label: 'good',
    from: 6,
    to: 8,  // 6-7 (6 <= score < 8)
};

const excellent: CompanyScoreType = {
    label: 'excellent',
    from: 8,
    to: 11,  // 8-10 (8 <= score < 11, includes 10.0)
};

export {poor, fair, good, excellent};

export const CompanyScoresArray = [
    excellent,
    good,
    fair,
    poor,
]